export type UserRole = "super_admin" | "admin" | "employee" | "client";

export const SUPER_ADMIN_UID = "jm2vaVfAlRY11kbmLZkR5foDIxA2";
export const SUPER_ADMIN_EMAIL = "mark@3pall.com";

export const ADMIN_ROLES: UserRole[] = ["super_admin", "admin"];
export const OPERATIONAL_ROLES: UserRole[] = ["super_admin", "admin", "employee"];
export const CLIENT_VISIBLE_ROLES: UserRole[] = ["client", "employee"];

export function isSuperAdminIdentity(uid?: string | null, email?: string | null): boolean {
  if (!uid && !email) return false;
  if (uid === SUPER_ADMIN_UID) return true;
  if (!email) return false;
  return email.trim().toLowerCase() === SUPER_ADMIN_EMAIL;
}

export function normalizeRole(
  role: UserRole | null | undefined,
  uid?: string | null,
  email?: string | null
): UserRole | null {
  if (isSuperAdminIdentity(uid, email)) {
    return "super_admin";
  }
  if (role === "admin" || role === "employee" || role === "client") {
    return role;
  }
  return null;
}

export function canAccessRole(role: UserRole, allowedRoles: UserRole[]): boolean {
  if (role === "super_admin" || role === "admin") {
    return true;
  }
  return allowedRoles.includes(role);
}
